<template>
  <nav>
    <v-card
        max-width="1200"
        class="mx-auto rounded-0"
        flat>
      <v-toolbar density="compact" color="white">
        <v-img :src="require('@/assets/img_logo.png')"
               class="ml-4"
               @click="$router.push('/')"
               max-width="180"
               cover
        ></v-img>
        <v-toolbar-items class="ml-4">
          <v-btn class="font-weight-bold" variant="text" @click="goToRoomPage">객실</v-btn>
          <v-btn class="font-weight-bold" variant="text" to="/upjang">주문/구매</v-btn>
          <v-btn class="font-weight-bold" variant="text" to="/ticket">티켓</v-btn>
          <v-btn class="font-weight-bold" variant="text" to="/order/history">구매 내역</v-btn>
          <v-btn class="font-weight-bold" variant="text" @click="goToHomePage">홈페이지</v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-btn
            v-if="!isAuth"
            to="/login"
            class="ml-2 rounded-0 bg-primary"
            size="small"
            variant="outlined">
          간편인증
        </v-btn>
        <v-btn
            v-if="isAuth"
            @click="onLogout"
            class="ml-2 rounded-0 bg-primary"
            size="small"
            variant="outlined">
          로그아웃
        </v-btn>
        <v-btn
            to="/membership"
            class="ml-2 rounded-0 bg-primary"
            size="small"
            variant="outlined">
          모바일회원권
        </v-btn>
        <div class="mx-auto ml-2">
          <v-select
              :items="corps"
              item-title="detail_name"
              item-value="detail"
              v-model="corp"
              density="compact"
              variant="outlined"
              location="bottom"
              @update:modelValue="changeRoute"
              hide-details></v-select>
        </div>
      </v-toolbar>
    </v-card>
    <v-divider></v-divider>
    <v-card
        max-width="1200"
        class="mx-auto mt-2 mb-2 rounded-0"
        justify="end"
        flat>
      <v-toolbar v-if="isAuth || hasCart" density="compact" color="white">
        <v-spacer></v-spacer>
        <v-chip v-if="isAuth" class="mr-2" color="grey-darken-3">
          {{formatPhoneNumber(authInfo.phoneNumber)}}
        </v-chip>

        <v-btn
            v-if="isAuth || hasCart"
            to="/cart"
            size="small"
            prepend-icon="mdi-cart-variant"
            class="ml-2 bg-primary"
            variant="outlined">
          장바구니
        </v-btn>
      </v-toolbar>
    </v-card>
  </nav>

  <form ref="sitePassForm" action="" method="POST">
    <input type="hidden" name="corp" :value="corpCode">
    <input type="hidden" name="passHpNo" :value="phoneNumber">
  </form>
</template>

<script>
import authStore from "@/store/auth";
import cartStore from "@/store/cart";
import commonStore from "@/store/common";
import {common} from "@/api";

export default {
  name: "WebNavbar",
  data () {
    return {
      isAuth: false,
      hasCart: false,
      authInfo: {},
      corps: [],
      corp: {},
      corpCode: '',
      corpName: '',
      phoneNumber : '',
    }
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.hasCart = cartStore.state.cart.cartKey !== null
    this.authInfo = authStore.state.authInfo
    this.corpCode = commonStore.state.common.corpCode
    this.corpName = commonStore.state.common.corpName
    this.phoneNumber = authStore.state.authInfo.phoneNumber
    this.getCorpsCodes()
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
    authInfo() {
      return authStore.state.authInfo
    },
    corpCode() {
      return commonStore.state.common.corpCode
    },
    corpName() {
      return commonStore.state.common.corpName
    },
    hasCart() {
      return cartStore.state.cart.cartKey !== null
    }
  },
  watch: {
    corp() {
      if ((typeof this.corp) === "string") {
        commonStore.dispatch('setCorpCode', this.corps.find(v => v.detail === this.corp))
      } else if ((typeof this.corp) === "object") {
        commonStore.dispatch('setCorpCode', this.corp)
      }
      this.corpName = commonStore.state.common.corpName
    }
  },
  methods: {
    getCorpsCodes() {
      common.getCommonCode(commonStore.state.common.corpCode, ['CI001'])
          .then(data => {
            console.log(data)

            if (data.data.codes) {
              this.corps = data.data.codes
              this.corp = this.corps.find(v => v.detail === this.corpCode)
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    onLogout() {
      authStore.dispatch('logout')
          .then(() => {
            cartStore.dispatch('removeCartInfo').then(r => r)
            this.$router.push('/')
          })
    },
    changeRoute() {
      if (this.$route.fullPath === '/') {
        this.$router.go(0)
      }
      this.$router.push('/')
    },
    goToHomePage() {
      window.location.href = "https://www.yongpyong.co.kr"
    },
    goToRoomPage() {
      const myForm = this.$refs.sitePassForm;
      myForm.action = process.env.VUE_APP_ROOM_SERVER_URL;
      myForm.submit();
      //window.location.href = process.env.VUE_APP_ROOM_SERVER_URL + "?corp=" + commonStore.state.common.corpCode + "&passHpNo=" + authStore.state.authInfo.phoneNumber
    }
  }
}
</script>

<style scoped>

</style>